module.exports = __webpack_public_path__ + "img/8c1d06c1f75d4171adbd3e5e7e594f1f-640.17f2436d.jpg";